import * as React from "react";
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Routes, Route } from "react-router-dom";
import AppTheme from "../../src/shared-theme/AppTheme";
import SideMenu from "./components/SideMenu";
import AppNavbar from "./components/AppNavbar";

// setting block create by mr_vk
import Role from "./components/Settings/Role";
import Profiles from "./components/Settings/Profiles";
import Vendor from "./components/Settings/VendorManagementTable";
import Division from "./components/Settings/Division";
import BankDetailsManagementTable from "./components/Settings/BankDetailsManagementTable ";
import Party from "./components/Settings/Party";
import Expense from "./components/Settings/Expense";
import ImprestMasterTable from "./components/Settings/Imprester";
import Adworker from "./components/Settings/Adworker";

//Administrator Block create by mr_vk
import PendingPoList from "./components/Administrator/PendingPoList";
import PendingSoList from "./components/Administrator/PendingSoList";
import PendingIndentList from "./components/Administrator/PendingIndentList";
import PendingPIList from "./components/Administrator/PendingPIList";
import PendingGeneralList from "./components/Administrator/PendingGeneralList";
import PendingPurchaseList from "./components/Administrator/PendingPurchaseList";
import PendingPaymentList from "./components/Administrator/PendingPaymentList";
import PendingSalesList from "./components/Administrator/PendingSaleslist";
import PendingReceiptList from "./components/Administrator/PendingReceiptList";

//Store Block create by mr_vk
import IndentForm from "./components/Indent/IndentForm";
import IndentList from "./components/Indent/IndentList";
import ItemForm from "./components/Inventory/ItemForm";
import Itemslist from "./components/Inventory/Itemslist";
import IssueForm from "./components/Inventory/IssueForm";
import IssuesList from "./components/Inventory/IssuesList";
import UnitManager from "./components/Inventory/UnitManager";
import Transporter from "./components/Inventory/Transporter";
import PoItemEntry from "./components/Inventory/PoItemEntry";
import PoItemList from "./components/Inventory/PoItemList";
import CategoryList from "./components/Inventory/CategoryList";
import SubCategoryList from "./components/Inventory/SubCategory";
import TransferList from "./components/Inventory/Transfer";
import TransferForm from "./components/Inventory/TransferForm";
import UnitList from "./components/Inventory/UnitList";
import POList from "./components/Purchase_order/Purchase_order_list";
import POForm from "./components/Purchase_order/Purchase_order";
import Purchasecard from "./components/Purchase_order/Purchasecard";
import POwithoutIndent from "./components/Purchase_order/PEwithoutIndent";
import PEwithoutIndent from "./components/Purchase_order/PEwithoutIndent";
import PurchaseList from "./components/Purchase_order/PurchaseList";
import PEwithIndent from "./components/Purchase_order/PEwithIndent";
import MOSProcurementDashboard from "./components/Purchase_order/MOSProcurementDashboard";
//Accounts Block create by mr_vk
import GeneralVoucher from "./components/Accounts/GeneralVoucher";
import PurchaseVouchers from "./components/Accounts/PurchaseVoucher";
import ContraVoucher from "./components/Accounts/ContraVoucher";
import ContraVoucherFrom from "./components/Accounts/ContraVoucherFrom";
// import DailyPayment from "./components/Accounts/Payments";
import SalesVoucher from "./components/Accounts/SalesVoucher";
import PaymentVoucher from "./components/Accounts/PaymentVoucher";
import CashPaymentForm from "./components/Accounts/CashPaymentForm";
import BankPaymentForm from "./components/Accounts/BankPaymentForm";
import NeftRtgsPaymentForm from "./components/Accounts/NeftRtgsPaymentForm";
import ReceiptVoucher from "./components/Accounts/ReceiptVoucher";
import CashLedger from "./components/Accounts/CashLedger";
import CreditorLedger from "./components/Accounts/CreditorLedger";
import BankLedger from "./components/Accounts/BankLedger";
import LedgerBook from "./components/Accounts/LedgerBook";
import GeneralVoucherForm from "./components/Accounts/GeneralVoucherForm";
import PurchaseVoucherForm from "./components/Accounts/PurchaseVoucherForm";
import PaymentVoucherForm from "./components/Accounts/PaymentVoucherForm";
import ReceiptVoucherForm from "./components/Accounts/ReceiptVoucherForm";
import Accountcard from "./components/Accounts/Accountcard";
import PerformaTable from "./components/Sale/PerformaTable";
import DashboardCards from "./components/Sale/Cards";
import SalesOrderEntry from "./components/Sale/Soentry";
import SaleOrderList from "./components/Sale/Solist";
import Performa from "./components/Sale/performa";
import SalesVoucherForm from "./components/Accounts/SalesVoucherForm";

//Academic and Enquiry block created by mr_vk
import QuotationForm from "./components/Quotation/QuotesForm";
import QuotationTable from "./components/Quotation/QuotationTable";
import CreateEnquiry from "./components/Enquiry/CreateEnquiry";
import EnquiryTable from "./components/Enquiry/EnquiryTable";
import Client from "./components/Academic/Client_feedback";
import Home1 from "./components/Home/Home1";
import Innerdashboard from "./components/Innerdashboard/Innerdashboard";

//reports created by mr_vk
import ProjectSummary from "./components/Reports/ProjectSummary";
import MonthlyPayIn from "./components/Reports/MonthlyPayIn";
import MonthlyPayOut from "./components/Reports/MonthlyPayOut";
import JournalVoucherByDivision from "./components/Reports/JournalVoucherByDivision";
import Saleorderbydate from "./components/Reports/Saleorderbydate";
import DailyPayment from "./components/Reports/DailyPayment";
import Pendingcontravoucher from "./components/Administrator/Pendingcontravoucher";
import PerformaByDate from "./components/Reports/PerformaByDate";

// stock reports
import StockSummaryTable from "./components/StockReports/StockSummary";
import StockLedger from "./components/StockReports/StockLedger";
import Material_inward_register from "./components/StockReports/Material_inward_register";
import Material_issue_register from "./components/StockReports/Material_issue_register";
import Department_wise_material_usage from "./components/StockReports/Department_wise_material_usage";
import MinimumStockAlertReport from "./components/StockReports/MinimumStockAlertReport";
import Value_of_closing_stock from "./components/StockReports/Value_of_closing_stock";
import MaterialReturnRegister from "./components/StockReports/MaterialReturnRegister";
import Item_wise_consumption_report from "./components/StockReports/Item_wise_consumption_report";
import GRN_PendingFor_Approval from "./components/StockReports/GRN_PendingFor_Approval";
import Fast_slow_moving_items from "./components/StockReports/Fast_slow_moving_items";
import PaymentCash from "./components/Accounts/PaymentCash";
import PaymentBank from "./components/Accounts/PaymentBank";
import PaymentNEFT_RTGS from "./components/Accounts/PaymentNEFT_RTGS";
import PaymentVouchersCash from "./components/Administrator/PaymentVouchersCash";
import PaymentVouchersBank from "./components/Administrator/PaymentVouchersBank";
import Sizelist from "./components/Inventory/Sizelist";
import Itemtypelist from "./components/Inventory/Itemtypelist";
import DesignAndDrawing from "./components/Operational Department/DesignDrawing";
import IBRFormalities from "./components/Operational Department/IBRFormalities";
import MaterialTestCertificateForm from "./components/Inventory/mtcForm";
import Mtclist from "./components/Inventory/MtcList";
import IndentReport from "./components/Reports/IndentReport";
import PoReport from "./components/Reports/PoReport";
import PoIndent from "./components/StockReports/PoIndent";
import PurchaseVoucherPO from "./components/StockReports/PurchaseVoucherPO";
import IssueMTCForm from "./components/Operational Department/IssueMtcForm";
import IssueMTCList from "./components/Operational Department/IssueMtcList";
import DivisionPage from "./components/Divisions";
import Purchaseentryform from "./components/Accounts/PurchaseVoucherFormWithoutPo";
import PurchaseVoucherFormWithoutPo from "./components/Accounts/PurchaseVoucherFormWithoutPo";
import PhaseOfProduct from "./components/Accounts/PhaseOfProduct"
import BOMCreationList from "./components/Accounts/BOMCreationList"
import BOMCreation from "./components/Accounts/BOMCreation"
import CompanyProfile from "./components/Accounts/CompanyProfile"
import VoltageRatio from "./components/Accounts/VoltageRatio"
import RatingSpecification from "./components/Accounts/RatingSpecification"
import WindingMaterial from "./components/Accounts/WindingMaterial"
import { ReserveStockLedgerList } from "../Services/Services";
import ReserveStockLedgerTable from "./components/StockReports/ReserveStockLedger";
import DepartmentManagement from "./components/Settings/DepartmentManagement";


export default function Dashboard(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <SideMenu />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            minWidth: 0, // ✅ Prevent overflow
            minHeight: "100vh",
          }}
        >
          <AppNavbar />
          <Box
            component="main"
            id="main-scroll-container"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: "auto",
              mt: {
                xs: "70px",
                md: "70px", 
              },
            })}
          >

          <Box sx={{ px: 3, pb: 3, ml: 1 }}>
            <Routes>
              <Route path="/unit-manager" element={<UnitManager />} />
              <Route path="/unit" element={<UnitList />} />
              <Route path="/size" element={<Sizelist/>}/>
              <Route path="/department" element={<DepartmentManagement />} />
              <Route path="/item-type" element={<Itemtypelist/>}/>
              <Route path="/po-form" element={<POForm />} />
              <Route path="/po-list" element={<POList />} />
              <Route path="/quotation" element={<QuotationTable />} />
              <Route path="/quotationForm" element={<QuotationForm />} />
              <Route path="/win-quotation" element={<QuotationTable resultFilter="win" />} />
              <Route path="/lose-quotation" element={<QuotationTable resultFilter="lose" />} />
              <Route path="/indent-form" element={<IndentForm />} />
              <Route path="/indent-list" element={<IndentList />} />
              <Route path="/role" element={<Role />} />
              <Route path="/profiles" element={<Profiles />} />
              <Route path="/Createenquiry" element={<CreateEnquiry />} />
              <Route path="/Enquiry" element={<EnquiryTable />} />
              <Route path="/client" element={<Client />} />
              <Route path="/vendor" element={<Vendor />} />
              {/* <Route path="/purchasevoucher" element={<PurchaseVoucher />} /> */}
              <Route path="/performaInvoice" element={<Performa />} />
              <Route path="/performaInvoice/:invoice_number" element={<Performa />} />
              <Route path="/saleorder/:id" element={<SalesOrderEntry />} />
              {/* <Route path="/inventory" element={<Inventory />} /> */}
              <Route path="/saleorder" element={<SalesOrderEntry />} />
              <Route path="/saleorderlist" element={<SaleOrderList />} />
              <Route path="/update" element={<PoItemEntry/>} />
              <Route path="/updatelist" element={<PoItemList/>} />
              <Route path="/" element={<Home1/>} />
              <Route path="/division" element={<Division />} />
              <Route path="/unit-manager" element={<UnitManager />} />
              <Route path="/category-list" element={<CategoryList />} />
              <Route path="/subcategory-list" element={<SubCategoryList />} />
              <Route path="/item-form" element={<ItemForm />} />
              <Route path="/item-list" element={<Itemslist />} />
              <Route path="/issue-form" element={<IssueForm />} />
              <Route path="/issue-list" element={<IssuesList />} />
              <Route path="/general-voucher" element={<GeneralVoucher />} />
                    <Route path="/general-voucher-create" element={<GeneralVoucherForm />} />
              <Route path="/purchase-voucher" element={<PurchaseVouchers />} />
              {/* <Route path="/payments" element={<DailyPayment/>} /> */}
              <Route path="/bank-accounts" element={<BankDetailsManagementTable/>} />
              <Route path="/Phase" element={<PhaseOfProduct/>}/>
              <Route path="/BOMcreation" element={<BOMCreation/>}/>
              <Route path="/BOMcreation/:id" element={<BOMCreation/>}/>
              <Route path="/BOMCreationList" element= {<BOMCreationList/>}/>

              <Route path="/WindingMaterial" element= {<WindingMaterial/>}/>
              <Route path="/VoltageRatio" element= {<VoltageRatio/>}/>
              <Route path="/RatingSpecification" element= {<RatingSpecification/>}/>

              <Route path="/CompanyProfile" element={<CompanyProfile/>}/>
              <Route path="/performatable" element={<PerformaTable />} />
              <Route path="/transporter" element={<Transporter/>} />
              <Route path="/transferlist" element={<TransferList/>} />
              <Route path="/transferform" element={<TransferForm/>} />
              <Route path="/sales-voucher-create" element={<SalesVoucherForm />} />
              <Route path="/contra-voucher" element={<ContraVoucher/>} />
              <Route path="/contra-voucher-create" element={<ContraVoucherFrom/>} />
              <Route path="/cards" element={<DashboardCards />} />
              <Route path="/accountcard" element={<Accountcard />} />
              
              <Route path="/innerdashboard" element={<Innerdashboard />} />
              <Route path="/po-form" element={<POForm />} />
              <Route path="/po-list" element={<POList />} />
              <Route path="/powithoutindent" element={<POwithoutIndent />} />
              <Route path="/pe-with-po" element={<PEwithIndent />} />
              <Route path="/purchase-list" element={<PurchaseList />} />
              <Route path="/mos-procurement" element={<MOSProcurementDashboard />} />
              
              <Route path="/projectsummary" element={<ProjectSummary />} />
              <Route path="/monthly-pay-in" element={<MonthlyPayIn />} />
              <Route path="/monthly-pay-out" element={<MonthlyPayOut />} />
              <Route path="/party" element={<Party />} />
              <Route path="/expense" element={<Expense />} />
              <Route path="/pending-po-list" element={<PendingPoList />} />
              <Route path="/pending-so-list" element={<PendingSoList />} />
              <Route path="/pending-indent-list" element={<PendingIndentList />} />
              <Route path="/pending-pi-list" element={<PendingPIList />} />
              <Route path="/pending-general-list" element={<PendingGeneralList />} />
              <Route path="/pending-purchase-list" element={<PendingPurchaseList />} />
              <Route path="/pending-payment-list" element={<PendingPaymentList />} />
              <Route path="/pending-payment-list-cash" element={<PaymentVouchersCash/>} />
              <Route path="/pending-payment-list-bank" element={<PaymentVouchersBank/>} />

                <Route path="/innerdashboard" element={<Innerdashboard />} />
                <Route path="/purchasecard" element={<Purchasecard />} />
                <Route path="/powithoutindent" element={<POwithoutIndent />} />
                {/* <Route path="/pe-without-po" element={<PurchaseVoucherFormWithoutPo />} /> */}
                <Route path="/pe-with-po" element={<PEwithIndent />} />
                <Route path="/purchase-list" element={<PurchaseList />} />

                <Route path="/projectsummary" element={<ProjectSummary />} />
                <Route path="/monthly-pay-in" element={<MonthlyPayIn />} />
                <Route path="/monthly-pay-out" element={<MonthlyPayOut />} />
                <Route path="/party" element={<Party />} />
                <Route path="/expense" element={<Expense />} />
                <Route path="/pending-po-list" element={<PendingPoList />} />
                <Route path="/pending-so-list" element={<PendingSoList />} />
                <Route
                  path="/pending-indent-list"
                  element={<PendingIndentList />}
                />
                <Route path="/pending-pi-list" element={<PendingPIList />} />
                <Route
                  path="/pending-general-list"
                  element={<PendingGeneralList />}
                />
                <Route
                  path="/pending-purchase-list"
                  element={<PendingPurchaseList />}
                />
                <Route
                  path="/pending-payment-list"
                  element={<PendingPaymentList />}
                />
                <Route
                  path="/pending-payment-list-cash"
                  element={<PaymentVouchersCash />}
                />
                <Route
                  path="/pending-payment-list-bank"
                  element={<PaymentVouchersBank />}
                />

                <Route path="/imprestmaster" element={<ImprestMasterTable />} />
                <Route path="/salesvoucher" element={<SalesVoucher />} />
                <Route path="/paymentvoucher" element={<PaymentVoucher />} />
                <Route path="/payment-cash" element={<PaymentCash />} />
                <Route path="/payment-bank" element={<PaymentBank />} />
                <Route path="payment-rtgs" element={<PaymentNEFT_RTGS />} />
                <Route path="/receiptvoucher" element={<ReceiptVoucher />} />
                <Route
                  path="/pending-sales-list"
                  element={<PendingSalesList />}
                />
                <Route
                  path="/pending-receipt-list"
                  element={<PendingReceiptList />}
                />

                {/* ======================MOS====================== */}
                <Route path="/cash-ledger" element={<CashLedger />} />

                <Route path="/bank-ledger" element={<BankLedger />} />
                <Route path="/ledger-book" element={<LedgerBook />} />
                <Route
                  path="/purchase-voucher-create"
                  element={<PurchaseVoucherForm />}
                />
                <Route path="/pe-without-po" element={<Purchaseentryform />} />

                <Route
                  path="/payment-voucher-create"
                  element={<PaymentVoucherForm />}
                />
                <Route
                  path="/payment-voucher-cash"
                  element={<CashPaymentForm />}
                />
                <Route
                  path="/payment-voucher-bank"
                  element={<BankPaymentForm />}
                />
                <Route
                  path="/payment-voucher-neft-rtgs"
                  element={<NeftRtgsPaymentForm />}
                />
                <Route
                  path="/receipt-voucher-create"
                  element={<ReceiptVoucherForm />}
                />
                <Route path="/advworker" element={<Adworker />} />
                <Route
                  path="/journal-voucher-by-division"
                  element={<JournalVoucherByDivision />}
                />
                <Route
                  path="/sale-order-by-date"
                  element={<Saleorderbydate />}
                />
                <Route path="/daily-payment" element={<DailyPayment />} />
                <Route
                  path="/pending-contra-list"
                  element={<Pendingcontravoucher />}
                />
                <Route
                  path="/performa-list-bydate"
                  element={<PerformaByDate />}
                />

                <Route path="/stock-summary" element={<StockSummaryTable />} />
                <Route path="/stock-ledger" element={<StockLedger />} />
                <Route
                  path="/material-inward-register"
                  element={<Material_inward_register />}
                />
                <Route
                  path="/material-issue-register"
                  element={<Material_issue_register />}
                />
                <Route
                  path="/department-wise-material-usage"
                  element={<Department_wise_material_usage />}
                />
                <Route
                  path="/minimum-stock-alert-report"
                  element={<MinimumStockAlertReport />}
                />
                <Route
                  path="/value-of-closing-stock"
                  element={<Value_of_closing_stock />}
                />
                <Route
                  path="/material-return-register"
                  element={<MaterialReturnRegister />}
                />
                <Route
                  path="/item-wise-consumption-report"
                  element={<Item_wise_consumption_report />}
                />
                <Route
                  path="/grn-pending-for-approval"
                  element={<GRN_PendingFor_Approval />}
                />
                <Route
                  path="/fast-slow-moving-items"
                  element={<Fast_slow_moving_items />}
                />
                <Route path="/indent-status" element={<IndentReport />} />
                <Route path="/po-status" element={<PoReport />} />
                <Route path="/po-indent" element={<PoIndent />} />
                <Route
                  path="/purchase-voucher-po"
                  element={<PurchaseVoucherPO />}
                />

                <Route
                  path="/design-and-drawing"
                  element={<DesignAndDrawing />}
                />
                <Route path="/ibr-formalities" element={<IBRFormalities />} />

                <Route
                  path="/mtc-form"
                  element={<MaterialTestCertificateForm />}
                />
                <Route path="/mtc-list" element={<Mtclist />} />
                <Route path="/issue-mtc-form" element={<IssueMTCForm />} />
                <Route path="/issue-mtc-list" element={<IssueMTCList />} />
                <Route path="/division-cards" element={<DivisionPage />} />
                <Route path="/reserve-stock-ledger" element={<ReserveStockLedgerTable/>}/>
              </Routes>
            </Box>
          </Box>
        </Box>
      </Box>
    </AppTheme>
  );
}
